module.exports = __webpack_public_path__ + "img/x23.9e8989c6.jpg";